import React from 'react';
import { Row, Col } from 'react-bootstrap';
import logo from '../assets/images/isologo_iosfa_byn_158x40.png';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faXTwitter, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';

export default function Footer() {
  return (
    <footer className="container-fluid footer bg-gris blanco">
      <Row className="px-3">
        <Col sm={10} className="app">
          <Row className="centrar-sm">
            <div>
              <a href="https://iosfa.gob.ar">
                <img className="app-logo" src={logo} alt="IOSFA" />
              </a>
            </div>
          </Row>
        </Col>
        <Col sm={2} className="app-descripcion centro-vertical text-right">
          <Col className="centrar-sm justify-content-end">
            <a href="https://www.facebook.com/IOSFA" target="_blank" rel="noopener noreferrer">
              <div className="centro-vertical padding-r-15">
                <span className="icon-circle bg-blanco gris">
                  <FontAwesomeIcon icon={faFacebookF} />
                </span>
              </div>
            </a>
            <a href="https://twitter.com/IOSFAoficial" target="_blank" rel="noopener noreferrer">
              <div className="centro-vertical padding-r-15">
                <span className="icon-circle bg-blanco gris">
                  <FontAwesomeIcon icon={faXTwitter} />
                </span>
              </div>
            </a>
            <a href="https://www.instagram.com/iosfa_oficial/" target="_blank" rel="noopener noreferrer">
              <div className="centro-vertical padding-r-15">
                <span className="icon-circle bg-blanco gris">
                  <FontAwesomeIcon icon={faInstagram} />
                </span>
              </div>
            </a>
            <a href="https://www.youtube.com/c/IOSFAoficial" target="_blank" rel="noopener noreferrer">
              <div className="centro-vertical padding-r-15">
                <span className="icon-circle bg-blanco gris">
                  <FontAwesomeIcon icon={faYoutube} />
                </span>
              </div>
            </a>
          </Col>
        </Col>
      </Row>
    </footer>
  );
}
